import { Text } from "north.js";
import React from "react";
import styled from "styled-components";

import { PhoneIcon, EmailIcon } from "src/static/icons";

interface ContactCardProps {
  name: string;
  title: string;
  phone?: string;
  email?: string;
}

const ContactCard: React.FC<ContactCardProps> = ({
  name,
  title,
  phone,
  email,
}) => {
  return (
    <CardContainer>
      <Text type="h3">{name}</Text>
      <StyledTitle>{title}</StyledTitle>
      {phone && (
        <StyledBody>
          <Flex>
            <PhoneIcon />
            <a href={`tel:${phone}`}>{phone}</a>
          </Flex>
        </StyledBody>
      )}
      {email && (
        <StyledBody>
          <Flex>
            <StyledEmailIcon />
            <a href={`mailto:${email}`}>{email}</a>
          </Flex>
        </StyledBody>
      )}
    </CardContainer>
  );
};

const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
`;

const StyledTitle = styled.body`
  color: var(--North-Text-Tertiary, #9ca3af);

  /* North/Text/Body1 Bold */
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 160%; /* 25.6px */
`;

const StyledBody = styled.body`
  color: var(--North-Text-Primary, #43afde);

  /* North/Text/Body1 */
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%; /* 24px */
`;

const Flex = styled.div`
  display: flex;
  height: 24px;
  align-items: center;
  gap: 8px;
  align-self: stretch;
`;

const StyledEmailIcon = styled(EmailIcon)`
  color: ${({ theme }) => theme.globalConstants.color.textPrimary};
`;

export default ContactCard;
